import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Logo from "../../assets/img/custom/logo.png";
import { Label, Input, Button, Form, Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import { forgetPassword } from "store/actions/authActions";

function ForgetPassword() {
  const [email, setEmail] = useState("");
  let dispatch = useDispatch();
  let auth = useSelector((state) => state.auth);
  return (
    <>
      <div className="text-center mt-5">
        <img src={Logo} alt="logo" className="logo" />
      </div>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          dispatch(forgetPassword(email));
        }}
      >
        <div className="auth-card">
          <h2 className="auth-heading">Forgot Password</h2>

          <Label className="mt-3 auth-label">
            <b>Email</b>
          </Label>
          <Input
            placeholder="name@gmail.com"
            required
            value={email}
            type="email"
            className=" custom-input"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="text-center">
          <Button
            disabled={!email}
            className="auth-button mt-4 mt-lg-5"
            type="submit"
          >
            {auth.passwordLoading ? <Spinner size="md" /> : "Send Email"}
          </Button>
        </div>
      </Form>
      <div className="mt-3 mx-0 mx-md-5 text-center">
        <Label className="auth-label">Remember Password?</Label>{" "}
        <Link to="/auth/login">
          <Label
            className="text-primary auth-label"
            style={{ cursor: "pointer" }}
          >
            {" "}
            <b>
              <u>Login</u>
            </b>
          </Label>
        </Link>
      </div>
    </>
  );
}

export default ForgetPassword;
